import { getRequest } from '@/framework/utils/request'
const request = getRequest('common')
// 2.2.5.5.1镜像类别列表
export function getCateListApi() {
  return request({
    url: process.env.VUE_APP_BASE_API + '/dockerImgTypes',
    method: 'get'
  })
}
// 2.2.5.5.2镜像类别添加
export function addCateNameApi(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/createDockerImgType',
    method: 'post',
    data
  })
}
// 1.1.4.5.6镜像子类别详情
export function getItemsApi(typeName) {
  return request({
    url: process.env.VUE_APP_BASE_API + `/subDockerImgTypes/${typeName}`,
    method: 'get'
  })
}
// 2.2.5.5.3镜像类别修改
export function cateEdit(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/updateDockerImgType',
    method: 'put',
    data
  })
}
// 2.2.5.5.4镜像类别删除
export function deletecate(typeId) {
  return request({
    url: process.env.VUE_APP_BASE_API + `/deleteDockerImgType/${typeId}`,
    method: 'post'
  })
}
// 2.2.5.3.1审核列表查询
export function getAuditListApi(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/publish/request',
    method: 'post',
    data
  })
}
// 审核接受
export function checkApi(data, publishRequestId) {
  return request({
    url: process.env.VUE_APP_BASE_API + `/publish/request/${publishRequestId}` + '?publishRequestId=' + publishRequestId,
    method: 'put',
    data
  })
}
// 2.2.5.2.1用户列表
export function getFormList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/users/userDetails',
    method: 'post',
    data
  })
}
// 2.2.5.2.2用户添加（管理员添加用户操作）
export function adduserForm(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/admin/addUser',
    method: 'post',
    data
  })
}
// 2.2.5.2.3用户修改（修改用户角色）
export function EditUserApi(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/roles/user/change',
    method: 'put',
    data
  })
}
// 2.2.5.2.4用户失效/激活
export function activeChange(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/users/user/deleteUser',
    method: 'post',
    data
  })
}
// 获取用户信息API
export function getuserInfoApi(data) {
  return request({
    url: '/portal/supplierAfterLogin/getUserInfo',
    method: 'get',
    params: data
  })
}
// 获取角色列表
export function getRoleListApi() {
  return request({
    url: process.env.VUE_APP_BASE_API + '/roles',
    method: 'get'
  })
}
// 获取消息列表
export function getInfoList(data, userId) {
  return request({
    url: process.env.VUE_APP_BASE_API + `/notifications/pagination/${userId}`,
    method: 'post',
    data
  })
}
export function getSearchList(query) {
  let params = {
    account: query.account
  }
  return request({
    url: process.env.VUE_APP_BASE_API + '/syform/search',
    method: 'get',
    params: params
  })
}

// 获得列表的接口
export function addForm(data) {
  let params = {
    power: data.power,
    a: data.a,
    b: data.b,
    c: data.c,
    d: data.d,
    e: data.e,
    account: data.account

  }
  return request({
    url: process.env.VUE_APP_BASE_API + '/syform/add',
    method: 'post',
    params
  })
}
// 添加角色
export function addRole(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/createRole',
    method: 'post',
    data
  })
}

// 编辑角色
export function editRole(params) {
  let data = {
    'request_body': {
      'name': params.name,
      'permissionList': params.permissionList
    }
  }
  return request({
    url: process.env.VUE_APP_BASE_API + `/updateRole/${params.roleId}` + '?roleId=' + params.roleId,
    method: 'put',
    data
  })
}
// 2.2.5.5.2添加子类的接口
export function editForm(data) {
  let params = {
    power: data.power,
    a: data.right[0].checked,
    b: data.right[1].checked,
    c: data.right[2].checked,
    d: data.right[3].checked,
    e: data.right[4].checked,
    id: data.id
  }
  return request({
    url: process.env.VUE_APP_BASE_API + '/syform/edit',
    method: 'post',
    params
  })
}

export function editfinal(data) {
  let params = {
    password: data.newpsw,
    id: data.id
  }
  return request({
    url: process.env.VUE_APP_BASE_API + '/syform/finaledit',
    // url: process.env.VUE_APP_BASE_API + '/users/changePassword',
    method: 'put',
    params
  })
}
export function keep(data) {
  let params = {
    account: data.account,
    email: data.email,
    id: data.id
  }
  return request({
    url: process.env.VUE_APP_BASE_API + '/syform/keep',
    method: 'post',
    params
  })
}

export function MirrorEditForm(data) {
  let params = {
    option: data.option,
    id: data.id
  }
  return request({
    url: process.env.VUE_APP_BASE_API + '/syform/mirroredit',
    method: 'post',
    params
  })
}
// 删除角色的接口
export function deleteRole(params) {
  return request({
    url: process.env.VUE_APP_BASE_API + `/deleteRole/${params.roleId}`,
    method: 'post'
  })
}
export function deleteUser(data) {
  let params = {
    power: data.power,
    id: data.id
  }
  return request({
    url: process.env.VUE_APP_BASE_API + '/syform/deluser',
    method: 'post',
    params
  })
}
export function delInfoApi(data, userId) { // 清除消息
  return request({
    url: process.env.VUE_APP_BASE_API + `/notifications/drop/user/${userId}`,
    method: 'delete',
    data
  })
}
export function markReadApi(data, userId) { // 标记已读
  return request({
    url: process.env.VUE_APP_BASE_API + `/notifications/view/user/${userId}`,
    method: 'put',
    data
  })
}
// 修改用户头像接口
export function updateUserImage(data) {
  let params = {
    userId: data
  }

  return request({
    url: process.env.VUE_APP_BASE_API + '/users/updateUserImage/',
    method: 'post',
    params
  })
}
// 用户注册接口
export function usersRegister(parames) {
  let data = {
    request_body: {
      username: parames.username,
      password: parames.password
    }
  }

  return request({
    url: process.env.VUE_APP_BASE_API + '/users/register',
    method: 'post',
    data
  })
}

// 更换用户头像
export function changeUserPictureApi(data, userId) {
  return request({
    url: process.env.VUE_APP_BASE_API + `/users/updateUserImage/${userId}`,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data
  })
}

// 修改用户密码
export function changeUserPasswordApi(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/users/changePassword',
    method: 'PUT',
    data
  })
}

// 修改用户基本信息
export function changeUserBaseInfoApi(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/users/updateUser',
    method: 'PUT',
    data
  })
}

// 获取未读通知数
export function getUnreadMessageApi(userId) {
  return request({
    url: process.env.VUE_APP_BASE_API + `/unreadnotifications/count/${userId}`,
    method: 'get'
  })
}

// 获取用户通知概要信息
export function getNotificationProfileApi(userId, data) {
  return request({
    url: process.env.VUE_APP_BASE_API + `/notifications/${userId}`,
    method: 'post',
    data
  })
}


